import React, { Component } from 'react';
import Store from 'eas-react-store';
import { Tools } from '../../tools/tools';

class WeekCard extends Component {
    renderGroups() {
        let result = [];
        let groups = [...this.props.store.Group.data];

        Tools.sortArrayByObjectKey(groups, 'id');

        groups.forEach((group) => {
            let item = group.name.split(" ")[1];

            if (group.id !== this.props.group?.id) {
                result.push(
                    <li
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.addGroup(group.id, this.props.week, this.props.group?.id, this.props.year);
                        }}
                        key={group.name}
                        className="group"
                    >
                        G{item}
                    </li>
                );
            }
        });

        if (this.props.group?.id != null) {
            result.push(
                <li
                    onClick={(e) => {
                        e.stopPropagation();
                        this.props.removeGroup(this.props.group?.id, this.props.week, this.props.year);
                    }}
                    key="trash"
                    className="group trash"
                >
                    <img src="/img/icon-remove-red.svg" alt="" />
                </li>
            );
        }

        return result;
    }

    render() {
        return (
            <div onClick={this.props.onClick} className="week-card">
                <div className={`week${String(Tools.getWeekNumberForDate(new Date(), Tools.firstWeekdayFromOrganisation(this.props.store.User.data.organisation))) === String(this.props.week) && (new Date()).getFullYear() === this.props.year ? " selected" : ""}`}>
                    {this.props.week}
                </div>

                <div className={`group ${this.props.group === "" ? "warning" : ""}`}>
                    {this.props.group !== "" && this.props.group?.name ? `G${this.props.group.name.split(' ')[1]}` : ""}
                    {this.props.group === "" &&
                        <p>
                            <img src="/img/icon-warning-orange.svg" alt="warning" />
                        </p>
                    }
                </div>
                <ul className={`select-group ${this.props.selectGroup === String(this.props.index) ? "" : "hidden"}`}>
                    {this.renderGroups()}
                </ul>
            </div>
        );
    }
}

export default Store.connectStore(WeekCard);